import { undefIfEmpty } from 'utils/validation';
import { formatAmount } from 'utils/formatting';
export const createRequestMessage = (amount, link, reference) => {
    const amt = formatAmount(amount, 'GBP', 2, false);
    const ref = undefIfEmpty(reference);
    const forRef = ref ? `for ${ref}` : '';
    return `Tap the link to pay me ${amt} with Emma ${forRef} 💸💸\n${link}`;
};
export const createPayMessage = (link, reference) => {
    const ref = undefIfEmpty(reference);
    return `Tap this link to download Emma, so I can pay you!\nemma.to/${link}\n${ref ?? ''}`;
};
